(function() {
  "use strict";
  require.config({
    baseUrl: '/scripts',
    shim: {
      underscore: {
        exports: "_"
      },
      marionette: {
        deps: ["backbone"],
        exports: "Marionette"
      },
      handlebars: {
        exports: "Handlebars",
        init: function() {
          this.Handlebars = Handlebars;
          return this.Handlebars;
        }
      },
      templates: {
        deps: ["handlebars"],
        exports: "templates"
      },
      moment: {
        exports: "moment"
      }
    },
    paths: {
      jquery: "../bower_components/jquery/dist/jquery",
      backbone: "../bower_components/backbone/backbone",
      marionette: '../bower_components/marionette/lib/backbone.marionette',
      underscore: "../bower_components/underscore/underscore",
      handlebars: "../bower_components/handlebars/handlebars.runtime",
      templates: "app/templates",
      moment: "../bower_components/moment/moment"
    }
  });

  require(['NowPlaying'], function(NowPlaying) {
    window.NowPlaying = new NowPlaying();
    return window.NowPlaying.start();
  });

}).call(this);

//# sourceMappingURL=main.js.map
;
define("main", function(){});

